module.exports = __webpack_public_path__ + "img/ring_r_i_null_null@2x.4bc1c34a.png";